const VEHICLE_TYPES = {
    CATALOG: 1,
    INVENTORY: 2,
};

export default VEHICLE_TYPES;
